import React, { useEffect, useState } from "react";
import { Card, Container, Form, Button } from "react-bootstrap";
import "./styles.scss";
import loader from "../../../assets/images/generate-report-loader.gif";
import { useHistory } from "react-router-dom";
import { Spring } from "react-spring/renderprops";
import { useForm } from "react-hook-form";

const GenerateReportLoading = ({
  setStep,
  handleGenerateReport,
  roofData,
  userAddress,
  errorMessage,
  setErrorMessage,
  refCode,
  roofType,
}) => {
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm();
  const [roofDataBackup, setRoofDataBackup] = useState();

  useEffect(() => {
    setRoofDataBackup(roofData);
    handleGenerateReport(
      roofData,
      userAddress,
      setStep,
      history,
      setErrorMessage,
      refCode,
      roofType
    );
  }, []);

  const submit = async (formData) => {
    setErrorMessage(false);

    handleGenerateReport(
      roofDataBackup,
      userAddress,
      setStep,
      history,
      setErrorMessage,
      refCode,
      roofType,
      formData.roofSquareSize
    );
  };

  return (
    <>
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={{ duration: 1000 }}
      >
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <Card className="shadow">
              <div className="loading-card-header-bg"></div>
              <div className="loading-text-content">
                {errorMessage && errorMessage === "ASK_ROOF_SQUARE_SIZE" ? (
                  <div className="roof_squar_size_form">
                    <h4 className="mb-5">
                      We need some more details to provide an accurate estimate.
                      Can you provide us with an estimate of your roof size in
                      sqFt ?
                    </h4>
                    <form onSubmit={handleSubmit(submit)}>
                      <Form.Group controlId="Roof SquareSize">
                        <Form.Control
                          type="number"
                          ref={register({ required: true })}
                          name="roofSquareSize"
                          placeholder={"3007"}
                          defaultValue={roofData?.roofSquareSize}
                        />
                      </Form.Group>
                      <Button
                        className="btn-block mt-5 py-2"
                        variant={"success"}
                        type="submit"
                      >
                        Get Report !
                      </Button>
                    </form>
                  </div>
                ) : (
                  <>
                    {" "}
                    <h4 className={errorMessage ? "text-danger" : ""}>
                      {" "}
                      {errorMessage
                        ? "We need some more details to provide an accurate estimate"
                        : "Generating Your Report!"}
                    </h4>
                    <p>
                      {" "}
                      {errorMessage
                        ? "Please call +1 (800) 401-7716 to have us provide an estimate for you"
                        : "We greatly appreciate your valuable time you spent here"}{" "}
                    </p>{" "}
                  </>
                )}

                {!errorMessage && (
                  <div>
                    <img
                      src={loader}
                      className="loading-gif"
                      alt="loading indicator"
                    />
                  </div>
                )}
              </div>
            </Card>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default GenerateReportLoading;
